import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import DayPicker from "react-day-picker";

import dotLoading from "../../../../assets/icons/dotLoading.svg";
import "./styles.scss";

// !!!!!!!!!!!!! DOCUMENTATION REACT-DAY-PICKER !!!!!!!!!!!!!!!!!!!!!!!!
// https://react-day-picker.js.org/docs/getting-started

// Composant permettant d'afficher l'autocomplétion des adresses google
// eslint-disable-next-line react/prop-types
export const DayPicking = ({MONTHS, WEEKDAYS_LONG, WEEKDAYS_SHORT, handleDayClick, selectedDay, ref}) => {

    const modifiersStyles = {
        selected: {
            color: "white",
            backgroundColor: "#FF6744",
            outline: "none"
        },
        wrapper: {
            outline: "none"
        }
    };
    let demain = new Date();
    const today = {time: new Date().getHours(), day: new Date().getDay()};
    const [tuesday, setTuesday] = useState(false);
    useEffect(() => {
        if ((today.day == 5) && (today.time >= 14)) setTuesday(true);
    }, []);

    return (
        <div ref={ref}>
            <DayPicker
                locale="fr"
                months={MONTHS}
                weekdaysLong={WEEKDAYS_LONG}
                weekdaysShort={WEEKDAYS_SHORT}
                onDayClick={handleDayClick}
                selectedDays={selectedDay}
                disabledDays={[
                    {before: new Date(new Date().getTime() + (24 * 60 * 60 * 1000))},
                    {day: new Date(new Date().getTime() + (24 * 60 * 60 * 1000))},
                    // {day: new Date(demain.getTime() + (24 * 60 * 60 * 1000))},
                    tuesday ? new Date(demain.getFullYear(), (demain.getMonth()), demain.getDate() + 1)
                        : null,
                    // if ((today.day = vendredi) && (today.time < 14h59)) {day: }
                    {daysOfWeek: [0]} // On sélectionne les jours non disponible. Ici 0 = dimanche
                ]}
                firstDayOfWeek={1}
                modifiersStyles={modifiersStyles}
            />
        </div>
    );
};

const Messages = ({messages, selectedDay, setSelectedDay, disableDatePicker, botIsLoading}) => {

    const MONTHS = [
        "Janvier",
        "Fevrier",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
    ];
    const WEEKDAYS_LONG = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
    ];
    const WEEKDAYS_SHORT = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];

    const lastListElement = useRef(null);

    useEffect(() => {
        // Scroll automatique lors d'un nouveau message
        if (lastListElement.current !== null)
            lastListElement.current.scrollIntoView(lastListElement);
    }, [messages, disableDatePicker]);

    const handleDayClick = (day, modifier = {}) => {
        // On s'assure que le user ne puisse pas sélectionné un jours non disponible
        if (modifier.disabled) {
            return;
        }
        // Si un jour disabled est sélectionné on renvoit undefined sinon, on met à jour la valeur de selectedDay par le jour sélectionné
        modifier.selected ? undefined : setSelectedDay(day);
    };

    return (
        <>
            {
                messages.map((message, index) => {
                    return (
                        <div key={index}>
                            <div className={`${message.type === "user" ? "bulle-droite" : "bulle-gauche"} fade`}>
                                <div
                                    className={`bulleMessage ${message.type === "user" ? "bulleUser" : "bulleCareManager"} fade`}>
                                    {message.message}
                                </div>

                                {/*{message.type == "botDatepicker" && !disableDatePicker &&*/}
                                {/*    <DayPicking*/}
                                {/*        ref={lastListElement}*/}
                                {/*        MONTHS={MONTHS}*/}
                                {/*        WEEKDAYS_LONG={WEEKDAYS_LONG}*/}
                                {/*        WEEKDAYS_SHORT={WEEKDAYS_SHORT}*/}
                                {/*        handleDayClick={handleDayClick}*/}
                                {/*        selectedDay={selectedDay}*/}
                                {/*    />*/}
                                {/*}*/}
                                <span className="date-envoi">{message.date}</span>
                            </div>
                            <div ref={lastListElement}/>
                        </div>
                    );
                })
            }
            {botIsLoading &&
                <div id="dotsMessage">
                    <img src={dotLoading}/>
                </div>
            }
            <div className="spacer-blur"></div>
        </>

    );
};

Messages.propTypes = {
    messages: PropTypes.array,
    selectedDay: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    setSelectedDay: PropTypes.func,
    disableDatePicker: PropTypes.bool,
    botIsLoading: PropTypes.bool,
};

export default Messages;